import React from 'react';
import Skeleton from "react-loading-skeleton";
function TitleSkeleton() {
    return(
        <h2>
            <Skeleton count={1} style={{marginBottom: "10px", lineHeight: 1.2}}  width={300}/>
        </h2>
    );
}
export default TitleSkeleton;